import React, { useState } from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import logo from '../Assets/SR_logo.png';

const links = [
    { to: '/', label: 'Home', end: true },
    { to: '/about', label: 'About' },
    { to: '/services', label: 'Services' },
    { to: '/projects', label: 'Projects' },
    { to: '/gallery', label: 'Gallery' },
    { to: '/clients', label: 'Clients' },
];

const Header = () => {
    const [expanded, setExpanded] = useState(false);

    return (
        <Navbar expand="lg" className="site-header" fixed="top" expanded={expanded} onToggle={setExpanded}>
            <Container>
                <Navbar.Brand as={NavLink} to="/" className="brand-lockup" onClick={() => setExpanded(false)}>
                    <img src={logo} alt="" height={46} />
                    <span>
                        <strong>Sona Alusys</strong>
                        <small>Industries</small>
                    </span>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="main-navbar" />
                <Navbar.Collapse id="main-navbar">
                    <Nav className="ms-auto align-items-lg-center">
                        {links.map((link) => (
                            <Nav.Link
                                key={link.to}
                                as={NavLink}
                                to={link.to}
                                end={link.end}
                                onClick={() => setExpanded(false)}
                            >
                                {link.label}
                            </Nav.Link>
                        ))}
                        <NavLink
                            to="/contact"
                            className={({ isActive }) => `nav-cta${isActive ? ' is-active' : ''}`}
                            onClick={() => setExpanded(false)}
                        >
                            Contact Us
                        </NavLink>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default Header;
